var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjectCategoryEvents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 36986"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 93",
    d: "M7.42207 6.66784L1.20678 20.0546C1.13126 20.2173 1.29144 20.3895 1.45911 20.3259L15.3197 15.0684C15.4203 15.0302 15.4721 14.9174 15.4371 14.8156C13.8013 10.0635 11.9869 8.20492 7.67476 6.5658C7.57713 6.52869 7.46606 6.57311 7.42207 6.66784Z",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 94",
    d: "M8 2C9.29287 3.04124 9.60384 4.02092 9.5 6",
    stroke: "currentColor",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 95",
    d: "M14 1C14.2439 3.92822 13.8872 5.46635 12.5 8",
    stroke: "currentColor",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 96",
    d: "M14 9.49889C16.4823 7.89606 18.0712 7.77251 21 8.49889",
    stroke: "currentColor",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 97",
    d: "M16.5 12.9978C18.5 12.4978 19.5 12.5 21 13.9978",
    stroke: "currentColor",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 594",
    cx: 11,
    cy: 2,
    r: 0.65,
    stroke: "currentColor",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 595",
    cx: 16,
    cy: 6,
    r: 0.65,
    stroke: "currentColor",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 596",
    cx: 17,
    cy: 10,
    r: 0.65,
    stroke: "currentColor",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 597",
    cx: 18,
    cy: 16,
    r: 0.65,
    stroke: "currentColor",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 90",
    d: "M5.59913 2.89458L5.54525 3.62462C5.54218 3.66619 5.56522 3.70531 5.60307 3.72278L6.35201 4.06847C6.4315 4.10516 6.42881 4.21905 6.34768 4.25194L5.59059 4.55891C5.56204 4.57048 5.54042 4.59457 5.53199 4.62419L5.27349 5.53186C5.24989 5.61474 5.13951 5.63095 5.09308 5.55835L4.64743 4.86162C4.62641 4.82875 4.58819 4.81111 4.54954 4.81643L3.73021 4.92928C3.64484 4.94104 3.58557 4.84653 3.63333 4.7748L4.15639 3.98925C4.17346 3.96361 4.17776 3.93153 4.16805 3.9023L3.91051 3.127C3.88292 3.04392 3.96784 2.96799 4.04732 3.00468L4.79627 3.35038C4.83411 3.36785 4.87883 3.36001 4.90847 3.3307L5.4291 2.81609C5.49482 2.75114 5.60593 2.80243 5.59913 2.89458Z",
    stroke: "currentColor",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 98",
    d: "M18.5991 1.89458L18.5452 2.62462C18.5422 2.66619 18.5652 2.70531 18.6031 2.72278L19.352 3.06847C19.4315 3.10516 19.4288 3.21905 19.3477 3.25194L18.5906 3.55891C18.562 3.57048 18.5404 3.59457 18.532 3.62419L18.2735 4.53186C18.2499 4.61474 18.1395 4.63095 18.0931 4.55835L17.6474 3.86162C17.6264 3.82875 17.5882 3.81111 17.5495 3.81643L16.7302 3.92928C16.6448 3.94104 16.5856 3.84653 16.6333 3.7748L17.1564 2.98925C17.1735 2.96361 17.1778 2.93153 17.1681 2.9023L16.9105 2.127C16.8829 2.04392 16.9678 1.96799 17.0473 2.00468L17.7963 2.35038C17.8341 2.36785 17.8788 2.36001 17.9085 2.3307L18.4291 1.81609C18.4948 1.75114 18.6059 1.80243 18.5991 1.89458Z",
    stroke: "currentColor",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectCategoryEvents);
export default __webpack_public_path__ + "static/media/project-category-events.9ee58e5b.svg";
export { ForwardRef as ReactComponent };